module.exports = __webpack_public_path__ + "img/cp-library-reference.36baa67e.svg";